/**
 * Date-extensions locale Finnish [fi]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('fi', {
    monthNames: ['Tammikuu','Helmikuu','Maaliskuu','Huhtikuu','Toukokuu','Kesäkuu','Heinäkuu','Elokuu','Syyskuu','Lokakuu','Marraskuu','Joulukuu'],
    monthShortNames: ['Tammi','Helmi','Maalis','Huhti','Touko','Kesä','Heinä','Elo','Syys','Loka','Marras','Joulu'],
    dayNames: ['Sunnuntai','Maanantai','Tiistai','Keskiviikko','Torstai','Perjantai','Lauantai'],
    dayShortNames: ['Su','Ma','Ti','Ke','To','Pe','La']
});
